import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface SkeletonLoaderProps {
  height?: string | number;
  width?: string | number;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
  height = '100%', 
  width = '100%' 
}) => {
  return (
    <Box 
      sx={{ 
        height, 
        width, 
        p: { xs: 1, sm: 2 },
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      {/* First rectangle - smaller */}
      <Skeleton 
        variant="rectangular" 
        height={120}
        sx={{ 
          width: '100%',
          borderRadius: 1
        }} 
      />
      
      {/* Second rectangle - larger */}
      <Skeleton 
        variant="rectangular" 
        height={280}
        sx={{ 
          width: '100%',
          borderRadius: 1
        }} 
      />
    </Box>
  );
};